const CaseStudyFooter = () => {
  return (
    <footer className="bg-white border-t border-zinc-200 py-10 text-xs text-zinc-500">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row  justify-between gap-6">
        
        <img
      src="/techqblack.png"
      alt="Techquitoes Logo"
      className="h-10 w-auto object-contain"
    />

        <p>© 2026 Techquitoes Solutions. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default CaseStudyFooter;